import { render, staticRenderFns } from "./RefuseWorkPrompt.vue?vue&type=template&id=ead85d30"
import script from "./RefuseWorkPrompt.vue?vue&type=script&lang=js"
export * from "./RefuseWorkPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports